import styled from '@emotion/styled';

const Footer = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '60px',
  justifyContent: 'left',
  alignItems: 'center',
  padding: '0 32px',
  '@media screen and (max-width: 1000px), screen and (max-height: 600px)': {
    justifyContent: 'center',
  },
});

export default Footer;
